"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOelBestaendigkeit = exports.OelBestaendigkeit = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
/**
 * Defines the industrial norm class of resistance vs Oil
 */
var OelBestaendigkeit;
(function (OelBestaendigkeit) {
    OelBestaendigkeit["Class1"] = "Class 1";
    OelBestaendigkeit["Class2"] = "Class 2";
    OelBestaendigkeit["Class3"] = "Class 3";
    OelBestaendigkeit["Class4"] = "Class 4";
    OelBestaendigkeit["Class5"] = "Class 5";
    OelBestaendigkeit["Class6"] = "Class 6";
    OelBestaendigkeit["Class7"] = "Class 7";
})(OelBestaendigkeit = exports.OelBestaendigkeit || (exports.OelBestaendigkeit = {}));
const isOelBestaendigkeit = (u) => {
    return (0, echain_shared_ts_utils_1.isValueInEnum)(OelBestaendigkeit, u);
};
exports.isOelBestaendigkeit = isOelBestaendigkeit;
//# sourceMappingURL=OelBestaendigkeit.js.map